import { GetOccupationZonesResponse } from "./types/occupations.types";
import occupationZonesData from "./data/occupation-zones.json";

export const getOccupationZones = async (): Promise<GetOccupationZonesResponse> => {
  return occupationZonesData as GetOccupationZonesResponse;
};

